<script setup>
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";

const { locale } = useI18n()

const items = computed(() => [
  {
    id: 1,
    label: 'Интернет',
    icon: '/img/shortcuts/internet.svg',
    href: `${import.meta.env.VITE_HOST}/${locale.value === 'en' ? 'kk' : locale.value}/katalog-uslug/internet-dlya-biznesa?utm_source=b2b-telecom&utm_medium=shortcut-icon&utm_campaign=main_page`
  },
  {
    id: 2,
    label: 'Телефония',
    icon: '/img/shortcuts/phone.svg',
    href: `${import.meta.env.VITE_HOST}/${locale.value}/katalog-uslug/sip-telefoniya?utm_source=b2b-telecom&utm_medium=shortcut-icon&utm_campaign=main_page`
  },
  {
    id: 3,
    label: 'Видеонаблюдение',
    icon: '/img/shortcuts/camera.svg',
    href: `${import.meta.env.VITE_HOST}/${locale.value === 'en' ? 'kk' : locale.value}/katalog-uslug/videonablyudenie-imou?utm_source=b2b-telecom&utm_medium=shortcut-icon&utm_campaign=main_page`
  },
  {
    id: 4,
    label: 'Домены',
    icon: '/img/shortcuts/domain.svg',
    href: `https://idhost.telecom.kz/cart.php?a=add&domain=register&language=${locale.value === 'kk' ? 'kazakh' : locale.value === 'ru' ? 'russian' : 'english'}`,
    event: "ym(96365240,'reachGoal','click-shortcut-icon-domen')"
  },
  {
    id: 5,
    label: 'Маркировка',
    icon: '/img/shortcuts/mark.svg',
    href: `https://tanba.telecom.kz/${locale.value === 'en' ? 'kk' : locale.value}?utm_source=b2b-telecom&utm_medium=shortcut-icon&utm_campaign=main_page`
  },
  {
    id: 6,
    label: 'Починить интернет',
    icon: '/img/shortcuts/tools.svg',
    href: `${import.meta.env.VITE_HOST}/${locale.value === 'en' ? 'kk' : locale.value}/pochinit-internet?utm_source=b2b-telecom&utm_medium=shortcut-icon&utm_campaign=main_page`
  },
  {
    id: 7,
    label: 'Личный кабинет',
    icon: '/img/shortcuts/user.svg',
    href: `${import.meta.env.VITE_HOST}/cabinet?lang=${locale.value}`,
    event: "ym(96365240,'reachGoal','click-shortcut-icon-lk')"
  },
  {
    id: 8,
    label: 'Поддержка',
    icon: '/img/shortcuts/support.svg',
    support: true,
    event: "ym(96365240,'reachGoal','click-shortcut-icon-support')"
  }
])

const emit = defineEmits(['openChatWidget']);


const isTruncated = ref(false);

const checkOverflow = (event) => {
  const el = event.currentTarget;
  // Если реальная ширина контента больше ширины самого блока — значит, текст обрезался
  isTruncated.value = el.scrollWidth > el.clientWidth;
};

const fireEvent = (event) => {
  if (!event) return
  try {
    const execute = new Function(event)
    execute()
  } catch (error) {}
}
</script>

<template>
  <section class="services-shortcuts">
    <div class="services-shortcuts__inner">
      <a
          v-for="item in items"
          :key="item.id"
          :href="item.href"
          @click="item.support ? emit('openChatWidget') : null; fireEvent(item.event)"
          class="services-shortcuts__item"
      >
        <div class="services-shortcuts__icon-wrap">
          <img
              :src="item.icon"
              :alt="item.label"
              class="services-shortcuts__icon"
          />
        </div>

        <v-tooltip :text="$t(item.label)" location="bottom" :disabled="!isTruncated">
          <template v-slot:activator="{ props }">
            <div v-bind="props" class="services-shortcuts__label" @mouseenter="checkOverflow">
              {{ $t(item.label) }}
            </div>
          </template>
        </v-tooltip>
      </a>
    </div>
  </section>
</template>

<style scoped lang="scss">
.services-shortcuts {
  width: 100%;
  background: #ffffff;
  border-radius: 0 0 0 0;
  padding: 64px 0 32px;
  margin-top: -32px;
  position: relative;
  z-index: 0;

  &__inner {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 24px;
    display: grid;
    grid-template-columns: repeat(8, minmax(0, 1fr));
    gap: 8px;
    align-items: start;
  }

  &__item {
    min-height: 104px;
    padding: 28px 8px 32px;
    border-radius: 16px;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    transition: background 0.2s ease, transform 0.2s ease;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: $hover-shortcut-color;
      .services-shortcuts__icon-wrap {
        transform: scale(1.1);
      }
    }
  }

  &__icon-wrap {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  &__icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__label {
    font-size: 16px;
    line-height: normal;
    font-weight: 400;
    color: #212529;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (max-width: 1440px) {
  .services-shortcuts {
    &__inner {
      padding: 0 80px
    }
  }
}


@media (max-width: 1024px) {

  .services-shortcuts {
    &__inner {
      padding: 0 64px
    }
    &__label {
      font-size: 14px
    }
  }
}

@media (max-width: 700px) {
  .services-shortcuts {
    padding: 40px 0 34px;
    margin-top: -20px;
    border-radius: 0 0 16px 16px;
  }

  .services-shortcuts__inner {
    max-width: none;
    width: 100%;
    margin: 0;
    padding: 0 24px;

    display: flex;
    grid-template-columns: unset;
    grid-auto-flow: unset;

    align-items: flex-start;
    justify-content: flex-start;
    gap: 22px;

    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x proximity;
    -webkit-overflow-scrolling: touch;

    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .services-shortcuts__item {
    width: 64px;
    min-width: 64px;
    max-width: 64px;
    flex: 0 0 64px;

    min-height: auto;
    padding: 0;
    margin: 0;
    border-radius: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    gap: 8px;
    text-align: center;

    &:hover {
      background: transparent;
      transform: none;
    }
  }

  .services-shortcuts__icon-wrap {
    width: 44px;
    height: 44px;
    margin: 0 auto;
  }

  .services-shortcuts__label {
    width: 64px;
    max-width: 64px;

    font-size: 11px;
    line-height: 1.15;
    text-align: center;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
